module.exports = __webpack_public_path__ + "img/chn.7a15fd41.png";